import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

// @ts-ignore
import Settle from './settle';
import SettleDetail from './settle-detail';
import SettleUpdate from './settle-update';
import SettleDeleteDialog from './settle-delete-dialog';
// settle routes
const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={SettleUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={SettleUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={SettleDetail} />
      <ErrorBoundaryRoute path={match.url} component={Settle} />
    </Switch>
    <ErrorBoundaryRoute path={`${match.url}/:id/delete`} component={SettleDeleteDialog} />
  </>
);

export default Routes;
